module.exports = __webpack_public_path__ + "img/loading-screen-spinner.7ff4afcd.gif";